import { Suspense } from "react";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { AppContextProvider } from "./context/AppContext";
import { AuthProvider } from "./context/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/custom.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Loader from "./components/Loader";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import GymTVLanding from "./pages/Auth/GymTVLanding";
import MobileControl from "./pages/Auth/MobileControl";
import AdminGymTV from "./pages/Auth/AdminGymTV";
import SignIn from "./pages/Auth/SignIn";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ResetPassword from "./pages/Auth/Reset";
import Error from "./pages/Error";
import Dashboard from "./pages/Auth/Dashboard";
import { UserContextProvider } from "./context/UserContext";
import { TransactionContextProvider } from "./context/TransactionContext";

import Register from "./pages/Auth/register.";
import OTPPage from "./pages/Auth/otp";
import StreamSection from "./pages/WebsiteLinkPage";
import Programme from "./pages/Programme";
import CoachView from "./pages/CoachView";
import PrivacyPolicy from "./pages/PrivacyPolicyPage";
import TermsAndConditions from "./pages/TermsAndCondition";

window.Buffer = window.Buffer || require("buffer").Buffer;
function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <AppContextProvider>
        <UserContextProvider>
          <Suspense fallback={<Loader />}>
            <BrowserRouter>
              <ScrollToTop />
              <ToastContainer closeOnClick={true} />
              <AppRoutes />
            </BrowserRouter>
          </Suspense>
        </UserContextProvider>
      </AppContextProvider>
    </AuthProvider>
    </ErrorBoundary>
  );
}

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<GymTVLanding />} />
      <Route path="/login" element={<SignIn />} />
      <Route path="/otp" element={<OTPPage />} />
      <Route path="/register" element={<Register />} />
      <Route path="/view/:gymCode" element={<CoachView />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset_password/:token" element={<ResetPassword />} />
  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/stream-section" element={<StreamSection />} />
        <Route path="/programme" element={<Programme />} />
      

        {/* <Route path="/profile" element={<ProfileIndex />} />
        <Route path="/edit-profile" element={<EditProfilePage />} />  */}
      </Route>

      <Route path="/control" element={<MobileControl />} />
      <Route path="/admin/gymtv" element={<AdminGymTV />} />
      <Route path="*" element={<Error />} />
    </Routes>
  );
};

const Layout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default App;
